<template>
    <div>
        <div class="nav">
            <v-head ></v-head>
        </div>
        <v-route :bindData="bindData"></v-route>
        <div class="container">
             <v-breadcrumb value1="首页" :value2="value2" :value3="value3" :url="url"></v-breadcrumb>
             <div class="container_box">
                     <div class="item_one" v-for="(v,index) in dataList" >
                         <div class="left" v-if="index%2===0">
                             <img class="hover" :src="v.coverImageUrl" @click="toDetail(v.path)" >
                         </div>
                         <div class="right" >
                             <div class="right_item">
                                 <div class="item_title" :class="{bigwidth:true}" >
                                     {{v.title}}
                                 </div>
                                 <p>{{v.summary}} </p>
                                 <div class="clear-fix"></div>
                                 <div class="item_more" @click="toDetail(v.path)" >
                                     <div class="item_more1">
                                     </div>
                                     <div class="item_more2">
                                         <img class="arrow" >
                                         <a  href="javascript:;">了解详情</a>
                                     </div>

                                 </div>
                             </div>
                         </div>
                         <div class="left"  v-if="index%2!==0">
                             <img class="hover" :src="v.coverImageUrl" @click="toDetail(v.path)" >
                         </div>
                     </div>
             </div>
        </div>
        <v-footer></v-footer>
    </div>
</template>

<script>
    import route from '../../components/common/route1'
    export default {
        name: "list1",
        data(){
            return{
                ljcode:null,
                columnId:null,
                rootColumnId:null,
                dataList:null,
                value2:null,
                value3:null,
                bindData:[
                    {
                        name:'廉江概览',
                        url:'#/list1?ljcode=ljgl&columnId=40288a9d6e91c70a016e91cabebd0006&rootColumnId=40288a9d6e91c70a016e91c787ba0000',
                        cid:'40288a9d6e91c70a016e91cabebd0006'
                    },
                    {
                        name:'廉江动态',
                        url:'#/list2?ljcode=ljdt&columnId=40288a9d6e91c70a016e91caf27c0007&rootColumnId=40288a9d6e91c70a016e91c787ba0000',
                        cid:'40288a9d6e91c70a016e91caf27c0007'
                    },
                    {
                        name:'节庆活动',
                        url:'#/jqhd?ljcode=jqhd&columnId=40288a9d6e91c70a016e91cb31640008&rootColumnId=40288a9d6e91c70a016e91c787ba0000',
                        cid:'40288a9d6e91c70a016e91cb31640008'
                    },
                    {
                        name:'音画廉江',
                        url:'#/yhlj?ljcode=yhlj&columnId=40288a9d6e91c70a016e91cb9d910009&rootColumnId=40288a9d6e91c70a016e91c787ba0000',
                        cid:'40288a9d6e91c70a016e91cb9d910009'
                    }
                ]
            }
        },
        watch:{
            $route:function (newValue) {
                this.ljcode = newValue.query.ljcode;
                if(this.ljcode == 'shgn'){
                    this.value2 = '廉江特色';
                    this.value3 = '赏花观鸟'
                }else {
                    this.value2 = '了解廉江';
                    this.value3 = '廉江概览'
                }
                this.columnId = newValue.query.columnId;
                this.rootColumnId = newValue.query.rootColumnId;
                this.url = [this.ljcode,this.rootColumnId,this.columnId];
                this.getList();
            }
        },
        created() {
            this.ljcode = this.$route.query.ljcode;
            if(this.ljcode == 'shgn'){
                this.value2 = '廉江特色';
                this.value3 = '赏花观鸟'
            }else {
                this.value2 = '了解廉江';
                this.value3 = '廉江概览'
            }
            this.columnId = this.$route.query.columnId;
            this.rootColumnId = this.$route.query.rootColumnId;
            this.url = [this.ljcode,this.rootColumnId,this.columnId];
            this.getList();
          //  this.getWidth();
        },
        methods:{
            getList(){
                let that = this;
                let url = `${api}/api/cms/article/list?rootColumnId=${this.rootColumnId}&columnId=${this.columnId}&type=&pageSize=10&currentPage=1`;
                this.common.axios.get(url).then(v=>{
                    let data = v.data.data.list;
                    console.log(data);
                    data.forEach(v=>{
                        v.coverImageUrl = apiimg+v.coverImageUrl;
                        v.path = `ljcode=${this.ljcode}&rootColumnId=${this.rootColumnId}&columnId=${this.columnId}&articleId=${v.id}`;
                        v.summary = v.summary.replace(/\s+/g," ");;
                    });
                    this.dataList = data;
                });
            },
            toDetail(v){
                // console.log(v)
                this.$router.push({path:`/detail?${v}`})
            }
        },
        components:{
            "v-route":route
        }
    }
</script>

<style lang="less" scoped>
    .bigwidth{
        width: 300px;
    }
    .nav{
        height: 350px;
        background: url("../../assets/img/headerbanner.jpg") no-repeat;
        background-size: cover;
    }
    .container_box{
        margin-top:30px;
        .i{
            display: block;
            margin: 0 auto;
            margin-top: 20px;
            margin-bottom: 10px;
        }
        .item_one{
            display: flex;
            flex-direction: row;
            .left{
                width: 50%;
                height: 461px;

                img{
                    width: 100%;
                    height: 100%;
                }
            }
            .right{
                position: relative;
                flex: 1;
                height: 461px;
                text-align: left;
                background: rgb(243,245,247);
                padding: 0 50px;
                .right_item{
                   // height: 230px;
                    .item_title{
                        color: black;
                        height: 38px;
                        width: 300px;
                      //  white-space: nowrap;
                      //  max-width: 300px;
                        line-height: 30px;
                        font-size: 30px;
                        margin: 56px 0 28px 0;
                    }
                    p{
                        text-align: left;
                        color: #999999;
                        font-size: 16px;
                        letter-spacing: 1px;
                        line-height: 30px;
                    }
                    .item_more{
                        .item_more1{
                            height: 50px;
                            width: 2px;
                            background: url("../../assets/img/ljlj/more.png");
                            background-size: cover;
                            margin: 14px 0 14px 20px;
                        }
                        .item_more2{
                            height: 30px;
                            line-height: 30px;
                            .arrow{
                                width: 27px !important;
                                height: 27px;
                                float: left;
                                margin: 0 20px 0 8px;
                                border-radius: 50%;
                                background: url("../../assets/img/ljlj/arrow.png");
                            }
                            a{
                                float: left;
                                height: 30px;
                                font-size:14px;
                                font-weight:400;
                                color:rgba(102,102,102,1);
                            }

                        }
                        .item_more2:hover{
                            .arrow{
                                background: url("../../assets/img/ljlj/arrow2.png");
                            }
                            a{
                                color:#FF6600;
                            }

                        }
                    }

                }
            }

        }
    }


</style>
